import en from "./en.json";
import fr from "./fr.json";

const messages = {
  en,
  fr,
};

export default messages;
